import axios from 'axios'
import {Toast} from 'vant'
import router from '../router'
import store from '../store'
import state from '../store/state'
import {loginInfo} from '@/common/js/loginInfo'

/**
 url: 接口地址
 data: 参数
 success：请求正确回调函数
 error：请求错误回调函数
 */
// 不需要token的请求
export const postJson = function(url, param, success, error) {
    submit(url, param, success, error)
}
// 导出excel
export const downFile = function(url, param, success, error) {
    let config = {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    axios.post(url, param, config, {responseType: 'blob'}).then(function (res) {
        if (res.status === 200) {
            if (res.headers.export === 'false' || !!res.headers.export) {
                store.commit('SET_LOADING', false)
                Toast.fail('导出数据为空,请重新导出！')
            } else {
                success(res.data)
            }
        } else {
          console.log(error)
          Toast.fail('系统错误，请联系管理员')
        }
    })
}
// 每次请求都验证token 需要token的请求
export const postToken = function(url, param, success, error) {
    if (!state.user.loginToken) {
        if (state.shop.ClientType === 3) {
            loginInfo()
        } else {
            router.push({name: 'MLogin'})
        }
    } else {
        submit(url, param, success, error)
    }
}
function submit(url, param, success, error) {
    let config = {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    axios.post(url, param, config).then(function (response) {
        const responseCode = response.status
        if (responseCode === 200) {
            if (response.data.code === '000' || response.data.fname) {
                success(response.data)
            } else {
                store.commit('SET_LOADING', false)
                let errorCode = response.data.code
                let errorMsg = JSON.parse(JSON.stringify(state.errorMsg))
                switch (errorCode) {
                case '401':
                  if (state.ClientType === 3) {
                        loginInfo()
                    } else {
                        router.push({name: 'MLogin'})
                    }
                    break
                case '402':
                    errorMsg.error404 = response.data.msg
                    store.commit('SET_ERRORMSG', errorMsg)
                    router.replace({name: 'MError404'})
                    break
                case '900':
                    break
                case '999':
                    Toast.fail(response.data.msg)
                    break
                case '998':
                    Toast.fail(response.data.msg)
                    break
                default: error(response.data)
                }
            }
        } else {
            error(error.response.data)
        }
    }).catch(error => {
        console.log(error)
    })
}
